import React from 'react'
import Header from '../components/public/shared/Header'
import { isAuthenticated } from '../utils/auth'
import Footer from '../components/public/shared/Footer'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { IconLookup } from '@fortawesome/fontawesome-common-types'

library.add({ icon: faLinkedin.icon, prefix: 'fab', iconName: 'linkedin' })

// const icon: IconLookup = {
// 	prefix: 'fab',
// 	iconName: 'linkedin'
// }

const basePath = process.env.BASE_PATH

interface ContactProps {
	authenticated: boolean
}

export const getServerSideProps = (ctx) => {
	return {
		props: {
			authenticated: isAuthenticated(ctx),
			title: 'Contact',
			description:
				"Contact us now if you're if you are a company or educator, interested in solving problems by student teams",
			url: `${basePath}/contact`,
		},
	}
}

class Contact extends React.Component<ContactProps> {
	constructor(props: any) {
		super(props)
	}

	render() {
		const { authenticated } = this.props

		return (
			<div className="wrapper bg-white min-h-screen">
				<Header authenticated={authenticated} />
				<main className="pt-20">
					<div className="relative py-10">
						<div className="container mx-auto px-4 relative z-10">
							<div className="max-w-lg bg-white mx-auto rounded-lg overflow-hidden pt-6">
								<h1 className="font-sans font-bold text-3xl mb-3 px-8 py-4 text-center">
									Contact
								</h1>

								<div className="px-8 pt-6 pb-8 mb-4">
									<p className="text-lg text-center">
										More information?
										<a
											className="block font-bold mt-3 hover:text-blue-600"
											href="tel:+31622090699"
										>
											+31 622 090 699
										</a>
										<a
											className="block font-bold mt-1 hover:text-blue-600"
											href="mailto:info@masterchallenge.me"
										>
											info@masterchallenge.me
										</a>
									</p>
								</div>
							</div>
						</div>
					</div>
				</main>
				<Footer />
			</div>
		)
	}
}

export default Contact
